import { render, staticRenderFns } from "./ServiceAndSupport.vue?vue&type=template&id=989d3df6&scoped=true&"
import script from "./ServiceAndSupport.vue?vue&type=script&lang=js&"
export * from "./ServiceAndSupport.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAndSupport.vue?vue&type=style&index=0&id=989d3df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989d3df6",
  null
  
)

export default component.exports